import { from, of } from 'rxjs';
import { publishReplay, refCount, switchMap } from 'rxjs/operators';
import { fetchQuery } from '@/services/messaging/fetchQuery';

export const allTreatmentAreas$ = of(1).pipe(
  switchMap(v => from(fetchQuery("GetAllTreatmentAreas", {}))),
  publishReplay(1),
  refCount()
);
